import { h, Component } from 'preact';

export default class Footer extends Component {
  render() {
    return (
      <footer class="flex">
        <p class="small">
          <span class="fa fa-copyright">&nbsp;</span>
          { new Date().getFullYear() }
          &nbsp;Rosenthal Fitness, LLC.
        </p>
        <div class="flex-auto social-links">
          <a
            href="https://www.instagram.com/rosenthalfitness/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <span class="fa fa-instagram" />
          </a>
          <a
            href="https://www.facebook.com/RosenthalFitness"
            rel="noopener noreferrer"
            target="_blank"
          >
            <span class="fa fa-facebook" />
          </a>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./components/footer.js